const useFormData = () => {
  const getSize = (payload: FileList | null) => {
    const files = Array.from(payload || []);
    return files.reduce((thing, { size }) => thing + size, 0);
  };
  /**
   * @parmas {FileList} files e.currentTarget.files
   * @parmas {number} limitSize MB 단위로 입력
   */
  const checkLimit = (files: FileList | null, limitSize: number) => {
    return getSize(files) > limitSize * 1024 * 1024;
  };
  const splitFileName = (payload: File) => {
    const splitName = payload.name.split(".");
    const extension = splitName[splitName.length - 1];
    const regExp = new RegExp(`.${extension}`, "gi");
    const fileName = payload.name.replace(regExp, "");

    return { name: fileName, extension: extension };
  };
  return { getSize, checkLimit, splitFileName };
};

export default useFormData;
